import logo from "Assets/images/logo.png";

const HeaderPreview = ({ heading }) => {
  return (
    <div className="top text-center position-relative">
      <div className="mb-4 imgWrp">
        <img src={logo} alt="" className="img-fluid" />
      </div>
      <h6 style={{ textTransform: "uppercase" }} className="m-0 py-2 fw-sbold report-title">
        {heading}
      </h6>
    </div>
  )
}


export default HeaderPreview;